// Função simples para recarregar permissões quando empresa muda
export const reloadPermissions = () => {
	// Dispara evento customizado para notificar que as permissões devem ser recarregadas
	const event = new CustomEvent('companyChanged');
	window.dispatchEvent(event);
};
